"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ChevronDownLargeSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M3.96966991,5.96966991 C4.23593648,5.70340335 4.65260016,5.6791973 4.94621165,5.89705176 L5.03033009,5.96966991 L9.5,10.439 L13.9696699,5.96966991 C14.2359365,5.70340335 14.6526002,5.6791973 14.9462117,5.89705176 L15.0303301,5.96966991 C15.2965966,6.23593648 15.3208027,6.65260016 15.1029482,6.94621165 L15.0303301,7.03033009 L9.5,12.5606602 L3.96966991,7.03033009 C3.6767767,6.73743687 3.6767767,6.26256313 3.96966991,5.96966991 Z" })));
};
ChevronDownLargeSmall.displayName = 'ChevronDownLargeSmall';
exports.default = ChevronDownLargeSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChevronDownLargeSmall.js.map